import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { useGetEventProcedure } from "security-app/hooks/useEventProceduresAPI";
import Form from "./Form";
import { INIT_EVENT_PROCEDURE } from "./utils";
function PluggableEventProcedureForm({
  eventProcedureId,
  remediationSteps = void 0,
  onClose = void 0,
  onSave = void 0,
  onRemove = void 0
}) {
  const { t } = useTranslation("enterprise_security_events");
  const { eventProcedure, loadingEventProcedure } = useGetEventProcedure(eventProcedureId);
  if (loadingEventProcedure) return /* @__PURE__ */ React.createElement(Spinner, { text: t("pluggable_form.loading") });
  if (remediationSteps) INIT_EVENT_PROCEDURE.description = remediationSteps;
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      eventProcedure: eventProcedure || INIT_EVENT_PROCEDURE,
      onSave,
      onDelete: onRemove,
      onCancel: onClose
    }
  );
}
export default PluggableEventProcedureForm;
